import { memo, useCallback, useState } from 'react';
import { useSelector } from '@bonanza-social/toolkit/state';
import { Box, Skeleton } from '@bonanza-social/moonlight';
import { selectGame } from '../../../../state';
import { DYNAMIC_IMAGE_PROPS, GAME_IMAGE_SIZES } from '../Game.content';
import { ThumbnailProps } from './Thumbnail.types';

function Thumbnail({
  gameId,
  type,
  dynamicSize,
  contentFit,
  ...rest
}: ThumbnailProps) {
  const game = useSelector(selectGame(gameId));
  const [loaded, setLoaded] = useState(false);
  const imageSrc = game?.gameImages[type]?.url;

  const onLoad = useCallback(() => setLoaded(true), []);

  return (
    <Box
      {...(dynamicSize ? DYNAMIC_IMAGE_PROPS[type] : GAME_IMAGE_SIZES[type])}
      {...rest}
    >
      {!loaded && <Skeleton position="absolute" width="100%" height="100%" />}
      {imageSrc ? (
        <img
          src={imageSrc}
          onLoad={onLoad}
          alt={game?.name}
          width="100%"
          height="100%"
        />
      ) : null}
    </Box>
  );
}

export default memo(Thumbnail);
